export default "__VITE_ASSET__c43e28b9__"